import { map } from 'lodash/fp';
import React from 'react';

import { ExplainedTerm } from '../../../../types/__codegen__/sanity/graphql';
import { PortableTextType } from '../../../../types/sanityInternal';
import uncapFpIterator from '../../../../../utils/uncap-fp-iterator';

const mapWithIndex = uncapFpIterator(map);

type PageSectionsProps = {
  components: {
    [key: string]: React.ElementType;
  };
  content:
    | ExplainedTerm
    | {
        sections: {
          compareButtonText: string;
          compareButtonToLink: string;
          productIds: string[];
          title?: PortableTextType[];
          type: string;
          withBorder: boolean;
        }[];
      };
};

const PageSections = ({ components, content }: PageSectionsProps) => {
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'sections' does not exist on type 'ExplainedTerm'.
  const sections = content?.sections;

  return (
    <>
      {mapWithIndex((section: { type: string }, index: React.Key) => {
        const Component = components[section.type] as typeof React.Component;
        if (!Component) return null;
        return <Component key={index} {...section} />;
      }, sections)}
    </>
  );
};

export default PageSections;
